<template>
    <div>
        <div class="main-content" id="panel">
            <header-component></header-component>
            <div class="header pb-5 bg-gradient-lighter pt-3">
                <div class="row ml-2 mr-2" v-if="usuario.tipo_usuario_pro == 2">
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="form-control-label" for="educationLevel">Nivel educativo</label>
                                            <b-form-select v-model="model.educationLevel" :options="educationLevel" id="educationLevel" name="educationLevel" value-field="id" text-field="sOption" required @change="getGrades"></b-form-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="form-control-label" for="grade">Grado</label>
                                            <b-form-select v-model="model.grade" :options="grades" id="grade" name="grade" value-field="id" text-field="sOption" required @change="getGroups"></b-form-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="form-control-label" for="group">Grupo</label>
                                            <b-form-select v-model="model.group" :options="groups" id="group" name="group" value-field="id" text-field="sOption" required></b-form-select>
                                        </div>
                                    </div>
                                    <button class="btn btn-primary btn-sm mx-auto" @click="getReport(0)" v-if="model.group > 0"><i class="fa fa-bars"></i> Mostrar reporte</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6" v-if="usuario.tipo_usuario_pro == 2 && model.group > 0">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="form-control-label" for="example3cols1Input">Progreso</label>
                                            <input type="text" class="form-control" id="example3cols1Input" placeholder="0.0" v-model="customWeighing.dProgressPercent">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="form-control-label" for="example3cols2Input">Cuestionario</label>
                                            <input type="text" class="form-control" id="example3cols2Input" placeholder="0.0" v-model="customWeighing.dQuizPercent">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="form-control-label" for="example3cols3Input">Práctica</label>
                                            <input type="text" class="form-control" id="example3cols3Input" placeholder="0.0" v-model="customWeighing.dSendProduct">
                                        </div>
                                    </div>
                                    
                                    <button class="btn btn-secondary btn-sm mx-auto" @click="saveWeighing"><i class="fa fa-save"></i> Guardar</button> <button class="btn btn-dark btn-sm mx-auto" @click="deleteWeighing"><i class="fa fa-trash"></i> Eliminar</button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container" v-if="usuario.tipo_usuario_pro != 2">
                    <div class="header-body">
                        <div class="row py-5">
                            <div class="col text-center">
                                <button type="button" class="btn btn-secondary mx-auto" @click="getStudentReport">Mostrar reporte</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page content -->
            <div class="container-fluid mt--6">
                <div class="card" v-if="students.length > 0 && usuario.tipo_usuario_pro == 2">
                    <!-- Card body -->
                    <div class="card-body">
                        <!--encabezados alumno-->
                        <div class="container">
                            <div class="row text-sm mb--2">
                                <div class="col-sm-4 ml--4"> 
                                    <h5><strong>Alumno</strong></h5>
                                </div>
                                <div class="col-sm-8">
                                    <div class="row">
                                        <div class="col-sm-3 ml-3">
                                            <span><strong>Progreso</strong></span>
                                        </div>
                                        <div class="col-sm-3 ml--1">
                                            <span><strong>Cuestionario</strong></span>
                                        </div>
                                        <div class="col-sm-3 ml--3">
                                            <span><strong>Práctica</strong></span>
                                        </div>
                                        <div class="col-sm-3 ml--3">
                                            <span><strong>Rendimiento</strong></span>
                                        </div>
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Inicia accordionAlumno1-->
                        <div class="accordion" :id="'accordionAlumno' + student.id" v-for="student in students" :key="student.id">
                            <div class="card card-report">
                                <div class="card-header-report" data-toggle="collapse" :data-target="'#proyecto' + student.id" aria-expanded="false" aria-controls="leccion1" @click.prevent="accordionClick(student.id)">
                                    <div class="row">
                                        <div class="col-sm-4">  
                                            <h5 class="mb-0">{{ student.sDescription }}</h5>
                                        </div>
                                        <div class="col-md-7 text-sm mt-1 mb--3">
                                            <div class="row">
                                                <div class="col-sm-3">
                                                    <span>{{ (student.dOverallProgress * 100).toFixed(2) }}%</span>
                                                </div>
                                                <div class="col-sm-3">
                                                    <span>{{ (student.dQuizResult * 100).toFixed(2) }}%</span>
                                                </div>
                                                <div class="col-sm-3">
                                                    <span>{{ (student.dSendFileSystem * 100).toFixed(2) }}%</span>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" :style="'width: '+student.dPerformance.toFixed(2) * 100+'%;'" :aria-valuenow="student.dPerformance.toFixed(2) * 100" aria-valuemin="0" aria-valuemax="100">{{ student.dPerformance.toFixed(2) * 100 }}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--Proyecto-->
                                <div :id="'proyecto' + student.id" class="collapse" :data-parent="'#accordionAlumno' + student.id" v-if="projects.length > 0">
                                    <div class="card-body">
                                        <div class="report-content1" v-for="studentProjects in projects.find( element => element.id == student.id ).values" :key="studentProjects.id">
                                            <!--encabezados Proyecto-->
                                            <div class="row text-sm pt-1">
                                                <div class="col-sm-3"> 
                                                    <h5><strong>Proyecto</strong></h5>
                                                </div>
                                                <div class="col-sm-8 mt-1 mb--3">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                        <span><strong>Progreso</strong></span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                        <span><strong>Cuestionario</strong></span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                        <span><strong>Práctica</strong></span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                        <span><strong>Rendimiento</strong></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--inicia row PROYECTO 1-->
                                            <div class="row text-sm pt-1">
                                                <div class="col-sm-3"> 
                                                    <a data-toggle="collapse" :href="'#leccion' + studentProjects.id + '_' + student.id" role="button" aria-expanded="false" aria-controls="leccion" @click.prevent="projectClick(studentProjects.id, student.id)">
                                                        <h5><i class="far fa-plus-square"></i> {{ studentProjects.sDescription }}</h5>
                                                    </a>
                                                </div>
                                                <div class="col-sm-8 mt-1 mb--3">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                            <span>{{ (studentProjects.dOverallProgress * 100).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <span>{{ (studentProjects.dQuizResult * 100).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <span>{{ (studentProjects.dSendFileSystem * 100).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="progress">
                                                                <div class="progress-bar" role="progressbar" :style="'width: '+ (studentProjects.dPerformance * 100).toFixed(0) +'%;'" :aria-valuenow="(studentProjects.dPerformance * 100).toFixed(0)" aria-valuemin="0" aria-valuemax="100">{{ (studentProjects.dPerformance * 100).toFixed(0) }}%</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--Inicia LECCIONES-->
										    <div class="collapse" :id="'leccion' + studentProjects.id + '_' + student.id">
                                                <template v-if="bLessons">
                                                    <div class="report-content2" v-for="studentLesson in projects.find( element => element.id == student.id ).values.find( value => value.id == studentProjects.id ).lessons" :key="studentLesson.id">
                                                        <!--encabezados Lecciones-->
                                                        <div class="row text-sm pt-1">
                                                            
                                                            <div class="col-sm-3"> 
                                                                <h5><strong>Lección</strong></h5>
                                                            </div>
                                                            
                                                            <div class="col-sm-8 mt-1 mb--3">
                                                                <div class="row">
                                                                    <div class="col-sm-3">
                                                                        <span><strong>Progreso</strong></span>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <span><strong>Cuestionario</strong></span>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <span><strong>Práctica</strong></span>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <span><strong>Rendimiento</strong></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div><!--termina encabezados-->
                                                        <!--inicia row de Leccion 1-->
                                                        <div class="row text-sm pt-1">
                                                            <div class="col-sm-3"> 
                                                                <a data-toggle="collapse" :href="'#etapa' + studentProjects.id + '_' + student.id + '_' + studentLesson.id" role="button" aria-expanded="false" aria-controls="etapa" @click.prevent="lessonClick(studentLesson.id, studentProjects.id, student.id)">
                                                                    <h5><i class="far fa-plus-square"></i> {{ studentLesson.sDescription }}</h5>
                                                                </a>
                                                            </div>
                                                            <div class="col-sm-8 mt-1 mb--3">
                                                                <div class="row">
                                                                    <div class="col-sm-3">
                                                                        <span>{{ (studentLesson.dOverallProgress * 100).toFixed(2) }}%</span>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <span>{{ (studentLesson.dQuizResult * 100).toFixed(2) }}%</span>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <span>{{ studentLesson.dSendFileSystem == null ? '' : (studentLesson.dSendFileSystem * 100).toFixed(2) + '%' }}</span>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <div class="progress">
                                                                            <div class="progress-bar" role="progressbar" :style="'width: '+ (studentLesson.dPerformance * 100).toFixed(0) +'%;'" :aria-valuenow="(studentLesson.dPerformance * 100).toFixed(0)" aria-valuemin="0" aria-valuemax="100">{{ (studentLesson.dPerformance * 100).toFixed(0) }}%</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!--termina row de Lección 1-->
                                                        <!--Inicia etapa -->
												        <div class="collapse" :id="'etapa' + studentProjects.id + '_' + student.id + '_' + studentLesson.id">
                                                            <template v-if="bStages">

                                                                <div class="report-content3" v-for="studentStage in projects.find( element => element.id == student.id ).values.find( value => value.id == studentProjects.id ).lessons.find( lesson => lesson.id == studentLesson.id ).stages" :key="studentStage.id">
                                                                    <!--encabezados etapa-->
                                                                    <div class="row text-sm pt-1">
                                                                        <div class="col-sm-4"> 
                                                                            <h5><strong>Etapa</strong></h5>
                                                                        </div>
                                                                        
                                                                        <div class="col-sm-8 mt-1 mb--3">
                                                                            <div class="row">
                                                                                <div class="col-sm-4">
                                                                                    <span><strong>Progreso</strong></span>
                                                                                </div>
                                                                                <div class="col-sm-4">
                                                                                    <span><strong>Cuestionario</strong></span>
                                                                                </div>
                                                                                <div class="col-sm-4">
                                                                                    <span><strong>Práctica</strong></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div><!--termina encabezados etapa-->
                                                                    <!--Inicia row de Etapa1-->
                                                                    <div class="row text-sm pt-1">
                                                                        <div class="col-sm-4"> 
                                                                            <a data-toggle="collapse" :href="'#paso' + studentProjects.id + '_' + student.id + '_' + studentLesson.id + '_' + studentStage.id" role="button" aria-expanded="false" aria-controls="paso" @click.prevent="stageClick(studentStage.id, studentLesson.id, studentProjects.id, student.id)"><h5><i class="far fa-plus-square"></i> {{ studentStage.sDescription }}</h5></a>
                                                                        </div>
                                                                        <div class="col-sm-8 mt-1 mb--3">
                                                                            <div class="row">
                                                                                <div class="col-sm-4">
                                                                                    <span>{{ (studentStage.dOverallProgress * 100).toFixed(2) }}%</span>
                                                                                </div>
                                                                                <div class="col-sm-4">
                                                                                    <span>{{ (studentStage.dQuizResult * 100).toFixed(2) }}%</span>
                                                                                </div>
                                                                                <div class="col-sm-4">
                                                                                    <span>{{ (studentStage.dSendFileSystem * 100).toFixed(2) }}%</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!--termina Row Etapa 1-->
                                                                    <!--inicia paso-->   
														            <div :id="'paso' + studentProjects.id + '_' + student.id + '_' + studentLesson.id + '_' + studentStage.id" class="collapse">
                                                                        <!--Report-content4-->
                                                                        <template v-if="bExams">
                                                                            <div class="report-content4" v-for="step in projects.find( element => element.id == student.id ).values.find( value => value.id == studentProjects.id ).lessons.find( lesson => lesson.id == studentLesson.id ).stages.find( stage => stage.id == studentStage.id ).steps" :key="step.id">
                                                                                <!--Inicia encabezados Pasos-->
                                                                                <div class="row text-sm pt-1">
                                                                                    <div class="col-sm-2"> 
                                                                                        <h5><strong>Paso</strong></h5>
                                                                                    </div>
                                                                                    
                                                                                    <div class="col-sm-10 mt-1 mb--3">
                                                                                        <div class="row">
                                                                                            <div class="col-sm-2">
                                                                                                <span><strong>Progreso</strong></span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span><strong>Cuestionario</strong></span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span><strong>Recibido</strong></span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span><strong>Ev. automática</strong></span>
                                                                                            </div> 
                                                                                            <div class="col-sm-2">
                                                                                                <span><strong>Ev. Manual</strong></span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span><strong>Activar calificación</strong></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div><!--termina encabezados Pasos-->
                                                                                <!--Inicia row de Paso 1-->
																                <div class="row text-sm pt-1">
                                                                                    <div class="col-sm-2"> 
                                                                                        <h5>{{ step.sDescription }}</h5>
                                                                                    </div>
                                                                                    <div class="col-sm-10 mt-1 mb--3">
                                                                                        <div class="row">
                                                                                            <div class="col-sm-2">
                                                                                                <span>{{ (step.dOverallProgress * 100).toFixed(2) }}%</span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span>{{ (step.dQuizResult * 100).toFixed(2) }}%</span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span>{{ step.sFileRecived == null ? '' : 'Sí' }}</span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span>{{ step.dSendFileSystem == null ? '' : (step.dSendFileSystem * 100).toFixed(2) + '%' }}</span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span>{{ step.dSendFileTeacher == null ? '' : (step.dSendFileTeacher * 100).toFixed(2) + '%' }}</span>
                                                                                            </div>
                                                                                            <div class="col-sm-2">
                                                                                                <span><a data-toggle="modal" data-target="#modal-form" href="#" @click="getResourceToEvaluate(step.id, student.id)">Calificar</a></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
																                </div>
                                                                            </div>
                                                                        </template>
														            </div>
                                                                    <!--termina id paso1-->
                                                                </div>
                                                            </template>
												        </div>
                                                    </div>
                                                </template>
										    </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="usuario.tipo_usuario_pro != 2">
                    <!-- Card body -->
                    <div class="card-body">
                        <!--encabezados-->
                        <div class="container"> 
                            <div class="row text-sm mb--2">
                                <div class="col-sm-4 ml--4"> 
                                    <h5><strong>Proyecto</strong></h5>
                                </div>
                                <div class="col-sm-8">
                                    <div class="row">
                                        <div class="col-sm-3 ml-3">
                                        <span><strong>Progreso</strong></span>
                                        </div>
                                        <div class="col-sm-3 ml--1">
                                        <span><strong>Cuestionario</strong></span>
                                        </div>
                                        <div class="col-sm-3 ml--3">
                                        <span><strong>Práctica</strong></span>
                                        </div>
                                        <div class="col-sm-3 ml--3">
                                        <span><strong>Rendimiento</strong></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--termina encabezados-->
                        <div class="accordion" :id="'accordionProyecto' + project.id" v-for="project in projects" :key="project.id">
                            <div class="card card-report">
                                <div class="card-header-report" :id="'P' + project.id" data-toggle="collapse" :data-target="'#leccion' + project.id" aria-expanded="false" aria-controls="collapseOne" @click.prevent="getStudentReportLevel2(project.id, project.idActivation)">
                                    <div class="row">
                                        <div class="col-sm-4">  
                                            <h5 class="mb-0">{{ project.sDescription }}</h5>
                                        </div>
                                        <div class="col-md-7 text-sm mt-1 mb--3">
                                            <div class="row">
                                                <div class="col-sm-3">
                                                    <span>{{ (project.dOverallProgress * 100).toFixed(2) }}%</span>
                                                </div>
                                                <div class="col-sm-3">
                                                    <span>{{ (project.dQuizResult * 100).toFixed(2) }}%</span>
                                                </div>
                                                <div class="col-sm-3">
                                                    <span>{{ (project.dSendFileSystem * 100).toFixed(2) }}%</span>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" :style="'width: '+project.dPerformance.toFixed(2) * 100+'%;'" :aria-valuenow="project.dPerformance.toFixed(2) * 100" aria-valuemin="0" aria-valuemax="100">{{ (project.dPerformance * 100).toFixed(2) }}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Proyecto-->
                            <!--Lección-->
                            <div :id="'leccion' + project.id" class="collapse" aria-labelledby="leccion" :data-parent="'#accordionProyecto' + project.id">
                                <div class="card-body">
                                    <template v-if="bLessons">
                                        <div class="report-content1" v-for="lesson in projects.find( proyecto => proyecto.id == project.id ).lessons" :key="lesson.id">
                                            <!--encabezados-->
                                            <div class="row text-sm pt-1">
                                                <div class="col-sm-3"> 
                                                        <h5><strong>Lección</strong></h5>
                                                </div>
                                                
                                                <div class="col-sm-8 mt-1 mb--3">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                        <span><strong>Progreso</strong></span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                        <span><strong>Cuestionario</strong></span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                        <span><strong>Práctica</strong></span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                        <span><strong>Rendimiento</strong></span>
                                                        </div>
                                                    
                                                    </div>
                                                </div> 
                                            </div><!--termina encabezados-->
                                            <!--inicia row de Leccion 1-->
                                            <div class="row text-sm pt-1">
                                                <div class="col-sm-3"> 
                                                    <a data-toggle="collapse" :href="'#etapa' + project.id + '_' + lesson.id" role="button" aria-expanded="false" aria-controls="etapa" @click.prevent="getStudentReportLevel3(project.id, project.idActivation, lesson.id)">
                                                        <h5><i class="far fa-plus-square"></i> {{ lesson.sDescription }}</h5>
                                                    </a>
                                                </div>
                                                <div class="col-sm-8 mt-1 mb--3">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                            <span>{{ (lesson.dOverallProgress * 100).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <span>{{ (lesson.dQuizResult * 100).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <span>{{ lesson.dSendFileSystem == null ? '' : (lesson.dSendFileSystem * 100).toFixed(2) + '%' }}</span>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="progress">
                                                                <div class="progress-bar" role="progressbar" :style="'width: '+ (lesson.dPerformance * 100).toFixed(0) +'%;'" :aria-valuenow="(lesson.dPerformance * 100).toFixed(0)" aria-valuemin="0" aria-valuemax="100">{{ (lesson.dPerformance * 100).toFixed(0) }}%</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--termina row de Lección 1-->
                                            <!--Inicia ETAPAS LECCION 1-->
                                            <div class="collapse" :id="'etapa' + project.id + '_' + lesson.id">
                                                <template v-if="bStages">
                                                    <div class="report-content2" v-for="stage in projects.find( proyecto => proyecto.id == project.id ).lessons.find( leccion => leccion.id == lesson.id ).stages" :key="stage.id">
                                                        <!--encabezados-->
                                                        <div class="row text-sm pt-1">
                                                            
                                                            <div class="col-sm-4"> 
                                                                <h5><strong>Etapa</strong></h5>
                                                            </div>
                                                            
                                                            <div class="col-sm-8 mt-1 mb--3">
                                                                <div class="row">
                                                                    <div class="col-sm-4">
                                                                    <span><strong>Progreso</strong></span>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                    <span><strong>Cuestionario</strong></span>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                    <span><strong>Práctica</strong></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div><!--termina encabezados-->
                                                        <!--Inicia row de Etapa1-->
                                                        <div class="row text-sm pt-1">
                                                            <div class="col-sm-4"> 
                                                                <a data-toggle="collapse" :href="'#paso' + project.id + '_' + lesson.id + '_' + stage.id" role="button" aria-expanded="false" aria-controls="paso" @click.prevent="getStudentReportLevel4(project.id, project.idActivation, lesson.id,stage.id)"><h5><i class="far fa-plus-square"></i> {{ stage.sDescription }}</h5></a>
                                                            </div>
                                                            <div class="col-sm-8 mt-1 mb--3">
                                                                <div class="row">
                                                                    <div class="col-sm-4">
                                                                        <span>{{ (stage.dOverallProgress * 100).toFixed(2) }}%</span>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <span>{{ (stage.dQuizResult * 100).toFixed(2) }}%</span>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <span>{{ (stage.dSendFileSystem * 100).toFixed(2) }}%</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!--termina Row Etapa 1-->
                                                        <!--Pasos de etapa 1-->
                                                        <div class="collapse" :id="'paso' + project.id + '_' + lesson.id + '_' + stage.id">
                                                            <template v-if="bExams">
                                                                <div class="report-content3" v-for="step in projects.find( proyecto => proyecto.id == project.id ).lessons.find( leccion => leccion.id == lesson.id ).stages.find( etapa => etapa.id == stage.id ).steps" :key="step.id">
                                                                    <!--encabezados-->
                                                                    <div class="row text-sm pt-1">
                                                                        <div class="col-sm-4"> 
                                                                            <h5><strong>Paso</strong></h5>
                                                                        </div>
                                                            
                                                                        <div class="col-sm-8 mt-1 mb--3">
                                                                            <div class="row">
                                                                                <div class="col-sm-3">
                                                                                <span><strong>Progreso</strong></span>
                                                                                </div>
                                                                                <div class="col-sm-3">
                                                                                <span><strong>Cuestionario</strong></span>
                                                                                </div>
                                                                                <div class="col-sm-3">
                                                                                <span><strong>Práctica</strong></span>
                                                                                </div>
                                                                                <div class="col-sm-3">
                                                                                <span><strong>Archivos</strong></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div><!--termina encabezados-->
                                                                    <!--Inicia row de Paso 1-->
                                                                    <div class="row text-sm pt-1">
                                                                        <div class="col-sm-4"> 
                                                                            <h5>{{ step.sDescription }}</h5>
                                                                        </div>
                                                                        <div class="col-sm-8 mt-1 mb--3">
                                                                            <div class="row">
                                                                                <div class="col-sm-3">
                                                                                    <span>{{ (step.dOverallProgress * 100).toFixed(2) }}%</span>
                                                                                </div>
                                                                                <div class="col-sm-3">
                                                                                    <span>{{ (step.dQuizResult * 100).toFixed(2) }}%</span>
                                                                                </div>
                                                                                <div class="col-sm-3">
                                                                                    <span>{{ step.dSendFileSystem == null ? '' : (step.dSendFileSystem * 100).toFixed(2) + '%' }}</span>
                                                                                </div>
                                                                                <div class="col-sm-3">
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Modal de activar curso-->	
		<div class="modal fade" id="modal-form" role="dialog" aria-labelledby="modal-form" aria-hidden="true">
			<div class="modal-dialog modal- modal-dialog-centered modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-body p-0">
						<div class="card bg-secondary border-0 mb-0">
							
							<div class="card-body px-lg-5 py-lg-5">
								<div class="text-center text-muted mb-4">
									Este es el proyecto del alumno o el vínculo que se subió
								</div>
                                <vue-form :state="formstate" @submit.prevent="update()">
                                    <div class="form-group">
										<validate tag="div">
                                            <label for="dCorrectPercentage" class="control-label">Calificación del alumno</label>
											<div class="input-group input-group-merge input-group-alternative">
												<input class="form-control" v-model="resourceToEvaluate.dCorrectPercentage" placeholder="Ingresa la calificación del alumno" type="text" name="dCorrectPercentage">
											</div>
										</validate>
									</div>
                                    <div class="text-center">
                                        <button type="submit" class="btn btn-primary my-4" data-toggle="#modal-form">Guardar</button>
                                    </div>
                                </vue-form>
                                <p align="justify">Si no puedes ver el contenido del archivo, haz clic en el siguiente vínculo para abrirlo o descargalo <a :href="resourceToEvaluate.sProductDetail" target="_blank">Abrir o descargar</a></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import NavigationComponent from '@/components/NavigationComponent'
import HeaderComponent from '@/components/HeaderComponent'
import VueForm from "vue-form"
import options from "../validations/validations.js";
Vue.use(VueForm, options);
export default {
    name: 'ReporteAvance',
    components: {
        NavigationComponent, HeaderComponent
    },
    data() {
        return {
            formstate: {},
            hostname: '',
            educationLevel: [],
            grades: [],
            groups: [],
            model: {
                educationLevel: 0,
                grade: 0,
                group: 0,
            },
            usuario: {},
            students: [],
            idAccordion: 0,
            idLeccion: 0,
            projects: [],
            lessons: [],
            idActivation: 0,
            bLessons: false,
            bStages: false,
            bExams: false,
            customWeighing: {},
            resourceToEvaluate: {},
            idPerson: 0,
        }
    },
    methods: {
        async getEducationLevel() {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/educationLevel', { headers: clientAPI })
            .then( (response) => {
                Swal.close()
                this.educationLevel = response.data.options
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getGrades(value) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/grades?idEduLevel=' + value, { headers: clientAPI })
            .then( (response) => {
                Swal.close()
                this.grades = response.data.options
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getGroups(value) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/groups?idGrade=' + value, { headers })
            .then( (response) => {
                Swal.close()
                this.groups = response.data.options
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getReport(iReportLevel) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/report?iReportLevel='+iReportLevel+'&idGroup=' + this.model.group, { headers })
            .then( (response) => {
                this.students = response.data.reportSource
                this.students.forEach( (element) => {
                    this.projects.push({id: element.id, values: []})
                } )
            })
            .catch( error => {
                this.catchError(error)
            })

            await axios.get(apiKS + 'api/rpt-ethinking/json/customWeighing?idGroup=' + this.model.group, { headers })
            .then( (response) => {
                Swal.close()
                this.customWeighing = response.data
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        accordionClick(id) {
            if(!$("#proyecto" + id).is(':visible'))
                this.getReportLevel1(id)
        },
        projectClick(idVersion, idActivation) {
            if(!$("#leccion" + idVersion + '_' + idActivation).is(':visible'))
                this.getReportLevel2(idVersion, idActivation)
        },

        lessonClick(idSubjectL1, idVersion, idActivation) {
            if(!$('#etapa' + idVersion + '_' + idActivation + '_' + idSubjectL1).is(':visible'))
                this.getReportLevel3(idSubjectL1, idVersion, idActivation)
        },
        stageClick(idExam, idSubjectL1, idVersion, idActivation) {
            if(!$('#paso' + idVersion + '_' + idActivation + '_' + idSubjectL1 + '_' + idExam).is(':visible'))
                this.getReportLevel4(idExam, idSubjectL1, idVersion, idActivation)
        },

        async getReportLevel1(id) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/report?iReportLevel=1&idGroup=' + this.model.group + '&idActivation=' + id, { headers })
            .then( (response) => {
                this.projects.find( element => element.id == id ).values = response.data.reportSource
            })
            .catch( error => {
                this.catchError(error)
            })
            Swal.close()
        },
        async getReportLevel2(idVersion, idActivation) {
            this.bLessons = false
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/report?iReportLevel=2&idGroup=' + this.model.group + '&idActivation=' + idActivation + '&idVersion=' + idVersion, { headers })
            .then( (response) => {
                this.projects.find( element => element.id == idActivation ).values.find( value => value.id == idVersion ).lessons = response.data.reportSource
                Swal.close()
            })
            .catch( error => {
                this.catchError(error)
            })

            this.bLessons = true
        },
        async getReportLevel3(idSubjectL1, idVersion, idActivation) {
            this.bStages = false
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/report?iReportLevel=3&idGroup=' + this.model.group + '&idActivation=' + idActivation + '&idVersion=' + idVersion + '&idSubjectL1=' + idSubjectL1, { headers })
            .then( (response) => {
                this.projects.find( element => element.id == idActivation ).values.find( value => value.id == idVersion ).lessons.find( lesson => lesson.id == idSubjectL1 ).stages = response.data.reportSource
                Swal.close()
            })
            .catch( error => {
                this.catchError(error)
            })

            this.bStages = true
        },
        async getReportLevel4(idExam, idSubjectL1, idVersion, idActivation) {
            this.bExams = false
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/report?iReportLevel=4&idGroup=' + this.model.group + '&idActivation=' + idActivation + '&idVersion=' + idVersion + '&idSubjectL1=' + idSubjectL1 + '&idExam=' + idExam, { headers })
            .then( (response) => {
                this.projects.find( element => element.id == idActivation ).values.find( value => value.id == idVersion ).lessons.find( lesson => lesson.id == idSubjectL1 ).stages.find( stage => stage.id == idExam ).steps = response.data.reportSource
                Swal.close()
            })
            .catch( error => {
                this.catchError(error)
            })

            this.bExams = true
        },

        async saveWeighing() {
            this.openLoading()
            await this.saveDataNoForm('api/ethinking/save-teacher-weighing', { idGroup: this.model.group, sProgressValue: this.customWeighing.dProgressPercent, sQuizValue: this.customWeighing.dQuizPercent, sSendProduct: this.customWeighing.dSendProduct }, '', '', null, 0, 1, null)
        },
        async deleteWeighing() {
            this.openLoading()
            await axios.post(apiKS + 'api/ethinking/restore-teacher-weighing?idGroup=' + this.model.group, {}, { headers })
            .then( (response) => {
                Swal.close()
                if(response.data.status == true) {
                    this.customWeighing = {}
                    Swal.fire({
                        title: "Exito",
                        text: response.data.message,
                        icon: "success",
                        onClose: () => {
                            this.getReport(0)
                        }
                    })
                }
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async update() {
            $("#modal-form").modal('hide')
            this.openLoading()
            await this.saveDataNoForm('api/ethinking/save-score', { idActivation: this.resourceToEvaluate.idActivation, idQuestion: this.resourceToEvaluate.idQuestion, sNewCaliffication: this.resourceToEvaluate.dCorrectPercentage }, '', '', null, 0, 1, null)
        },
        async getResourceToEvaluate(idQuestion, idActivation) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/getResourceToEvaluate?idQuestion=' + idQuestion + '&idActivation=' + idActivation, { headers })
            .then( (response) => {
                this.resourceToEvaluate = response.data
                this.resourceToEvaluate.idQuestion = idQuestion
                Swal.close()
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getStudentReport() {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/student?iReportLevel=1&idPerson=' + this.idPerson, { headers })
            .then( (response) => {
                Swal.close()
                this.projects = response.data.reportSource
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getStudentReportLevel2(idVersion, idActivation) {
            this.bLessons = false
            if(!$("#leccion" + idVersion).is(':visible')) {
                this.openLoading()
                await axios.get(apiKS + 'api/rpt-ethinking/json/student?iReportLevel=2&idPerson=' + this.idPerson + '&idActivation=' + idActivation + '&idVersion=' + idVersion, { headers })
                .then( (response) => {
                    this.projects.find( project => project.id == idVersion ).lessons = response.data.reportSource
                    Swal.close()
                })
                .catch( error => {
                    this.catchError(error)
                })
            }
            this.bLessons = true
        },

        async getStudentReportLevel3(idVersion, idActivation, idSubjectL1) {
            this.bStages = false
            if(!$('#etapa' + idVersion + '_' + idSubjectL1).is(':visible')) {
                this.openLoading()
                await axios.get(apiKS + 'api/rpt-ethinking/json/student?iReportLevel=3&idPerson=' + this.idPerson + '&idActivation=' + idActivation + '&idVersion=' + idVersion + '&idSubjectL1=' + idSubjectL1, { headers })
                .then( (response) => {
                    this.projects.find( project => project.id == idVersion ).lessons.find( value => value.id == idSubjectL1 ).stages = response.data.reportSource
                    Swal.close()
                })
                .catch( error => {
                    this.catchError(error)
                })
            }

            this.bStages = true
        },
        async getStudentReportLevel4(idVersion, idActivation, idSubjectL1, idExam) {
            this.bExams = false
            if(!$('#paso' + idVersion + '_' + idSubjectL1 + '_' + idExam).is(':visible')) {
                this.openLoading()
                await axios.get(apiKS + 'api/rpt-ethinking/json/report?iReportLevel=4&idPerson=' + this.idPerson + '&idActivation=' + idActivation + '&idVersion=' + idVersion + '&idSubjectL1=' + idSubjectL1 + '&idExam=' + idExam, { headers })
                .then( (response) => {
                    this.projects.find( project => project.id == idVersion ).lessons.find( value => value.id == idSubjectL1 ).stages.find( stage => stage.id == idExam ).steps = response.data.reportSource
                    Swal.close()
                })
                .catch( error => {
                    this.catchError(error)
                })
            }

            this.bExams = true
        }
    },
    async mounted() {
        this.hostname = hostname
        if(!user) {
            await this.getUserApi()
            this.usuario = user
        } else {
            this.usuario = user
        }

        if(this.usuario.tipo_usuario_pro == 2)
            await this.getEducationLevel()
    },
    watch: {
        
    }
}
</script>